import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/Homepage/Home';
import AboutUs from './components/Aboutus/AboutUs';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import Terms from './components/Terms/Terms';
// import SucessStory from './components/SucessStory/SucessStory';
import Careers from './components/Careers/Careers';
import Contactus from './components/Contactus/Contactus';
import InjectionMould from './components/InjectionMould/InjectionMould';
import PCBManufucture from './components/PCBManufucture/PCBManufucture';
import Wirringharness from './components/Wirringharness/Wirringharness';
import CableAssembly from './components/CableAssembly/CableAssembly';
import LarchMes from './components/LarchMes/LarchMes';
import LarchErp from './components/LarchErp/LarchErp';
import Automotive from './components/Automotive/Automotive';
import Manufacturing from './components/Manufacturing/Manufacturing';
import Logistics from './components/Logistics/Logistics';
import IOT from './components/IOT/IOT';
import AI_ML from './components/AI_ML/AI_ML';
import BigDataAnalytics from './components/BigDataAnalytics/BigDataAnalytics';
import Mobility from './components/Mobility/Mobility';
import './index.css';
import Page from './components/page';


// import ERPChatbot from './components/ERPChatbot/ERPChatbot';


function App() {
return (
    <Router>
      <Routes>
        <Route path="/" element={<Page title="Digital Transformation | IT Mordernization"><Homepage /></Page>} />
        <Route path="/about" element={<Page title="AboutUs"><AboutUs /></Page>} /> {/* ✅ About Us page */}
         <Route path="/PrivacyPolicy" element={<Page title="AboutUs"><PrivacyPolicy /></Page>} />
          <Route path="/Terms" element={<Page title="Terms"><Terms /></Page>} />
           {/* <Route path="/SucessStory" element={<SucessStory />} /> */}
            <Route path="/Careers" element={<Page title="Careers"><Careers /></Page>} />
            <Route path="/Contactus" element={<Page title="Contactus"><Contactus /></Page>} />
             <Route path="/injection-mould" element={<Page title="InjectionMould"><InjectionMould /></Page>} />
             <Route path="/PCBManufucture" element={<Page title="PCBManufucture"><PCBManufucture /></Page>} />
              <Route path="/Wirringharness" element={<Page title="Wirringharness"><Wirringharness /></Page>} />
               <Route path="/CableAssembly" element={<Page title="CableAssembly"><CableAssembly /></Page>} />
               <Route path="/LarchMes" element={<Page title="LarchMes"><LarchMes /></Page>} />
               <Route path="/LarchErp" element={<Page title="LarchErp"><LarchErp /></Page>} />
               <Route path="/Automotive" element={<Page title="Automotive"><Automotive /></Page>} />
                <Route path="/Manufacturing" element={<Page title="Manufacturing"><Manufacturing /></Page>} />
                <Route path="/Logistics" element={<Page title="Logistics"><Logistics /></Page>} />
                <Route path="/IOT" element={<Page title="IOT"><IOT /></Page>} />
                <Route path="/AI_ML" element={<Page title="AI/ML"><AI_ML /></Page>} />
                <Route path="/BigDataAnalytics" element={<Page title="BigDataAnalytics"><BigDataAnalytics /></Page>} />
                <Route path="/Mobility" element={<Page title="Mobility"><Mobility /></Page>} />
      </Routes>
    </Router>
  );
}


export default App;


